export default "__VITE_ASSET__Dqpwmeom__"